<app-list-header [headerName]="'Готовые уроки'"></app-list-header>
<app-lessons-list
        [lessonStatus]="lesson_created"
        [studentClassId]="classId"
        [subjectId]="subjectId"
        [showHeader]="false"
        *ngIf="teacher && classId && subjectId">
</app-lessons-list>
